module.exports = "<p class=\"text-danger\">\n  {{ errorMessage }}\n</p>\n"